document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".video-autoplay iframe, .video-autoplay video");

  function ensureApiParams(el) {
    if (el.tagName !== "IFRAME") return;

    let src = el.getAttribute("src") || "";

    // YouTube needs enablejsapi=1
    if (src.includes("youtube") && !src.includes("enablejsapi=1")) {
      const separator = src.includes("?") ? "&" : "?";
      el.src = src + separator + "enablejsapi=1";
    }

    // Vimeo needs api=1
    if (src.includes("vimeo") && !src.includes("api=1")) {
      const separator = src.includes("?") ? "&" : "?";
      el.src = src + separator + "api=1";
    }
  }

  videos.forEach(video => ensureApiParams(video));

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const el = entry.target;

      if (entry.isIntersecting) {
        // YouTube autoplay
        if (el.tagName === "IFRAME" && el.src.includes("youtube")) {
          el.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}', '*'
          );
        }
        // Vimeo autoplay
        else if (el.tagName === "IFRAME" && el.src.includes("vimeo")) {
          el.contentWindow.postMessage('{"method":"play"}', '*');
        }
        // HTML5 video autoplay
        else if (el.tagName === "VIDEO") {
          el.play().catch(() => { }); // prevent autoplay errors
        }
      } else {
        // Pause when leaving screen
        if (el.tagName === "IFRAME" && el.src.includes("youtube")) {
          el.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}', '*'
          );
        } else if (el.tagName === "IFRAME" && el.src.includes("vimeo")) {
          el.contentWindow.postMessage('{"method":"pause"}', '*');
        } else if (el.tagName === "VIDEO") {
          el.pause();
        }
      }
    });
  }, { threshold: 0.2 });

  videos.forEach(video => observer.observe(video));
});